<mat-card class="exporter-card">
  <mat-card-header>
    <mat-card-title>Advanced Log Exporter</mat-card-title>
    <mat-card-subtitle>Select dates and columns to export</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div class="date-range">
      <mat-form-field appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="pickerStart"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="pickerEnd"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
    </div>

    <h3>Select Columns</h3>
    <div class="column-grid">
      <div *ngFor="let col of columns()" class="column-item">
        <mat-checkbox [(ngModel)]="col.selected">
          {{ col.label }}
        </mat-checkbox>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions class="actions">
    <button
      mat-flat-button
      color="primary"
      [disabled]="isExporting()"
      (click)="exportData('csv')"
    >
      <mat-spinner diameter="20" *ngIf="isExporting()"></mat-spinner>
      Export CSV
    </button>
    <button
      mat-stroked-button
      color="accent"
      [disabled]="isExporting()"
      (click)="exportData('html')"
    >
      Export HTML Repor
    </button>
  </mat-card-actions>
</mat-card>
